import React, { Component } from 'react'

import { connect } from 'react-redux'
import { snackbarDispose } from '../../reducers/snackbar/action'
import translator from '../../translate'
import { withSnackbar } from 'notistack'
import Preloader from '../../components/preloader'
import parse from 'html-react-parser'
// material
import { styled } from '@material-ui/core/styles'
import { Box, Card, Link, Container, Typography } from '@material-ui/core'
// hooks
// routes
// layouts
import AuthLayout from '../../layouts/AuthLayout'
// components
import Page from '../../components/Page'
import { MHidden } from '../../components/@material-extend'
import { RegisterForm } from '../../components/authentication/register'
import AuthFirebaseSocials from '../../components/authentication/AuthFirebaseSocial'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({

  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

class Register extends Component {
  render() {
    const { process } = this.props
    return (
      <RootStyle title="Register | Mini-Course Generator">
        <AuthLayout>
          {translator._('signUp.alreayHaveAnAccount')} &nbsp;
          <Link underline="none" variant="subtitle2" href="login">
            {translator._('loginPage.signIn')}
          </Link>
        </AuthLayout>
        {process && <Preloader process={process} />}

        <MHidden width="mdDown">
          <SectionStyle>
            <Box style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography sx={{ pl: 3, mt: 10, mb: 5 }}>
                <Typography variant="h3">
                  {parse(translator._('signUp.signUpHero2'))}
                </Typography>
              </Typography>
            </Box>
          </SectionStyle>
        </MHidden>

        <Container>
          <ContentStyle>
            <Box sx={{ mb: 5, display: 'flex', alignItems: 'center' }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  {translator._('signUp.getStartedAbsolutelyFree')}
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  {translator._('signUp.freeForever')}
                </Typography>
              </Box>
            </Box>

            <AuthFirebaseSocials />

            <RegisterForm {...this.props} />

            <MHidden width="smUp">
              <Typography
                variant="subtitle2"
                sx={{ mt: 3, textAlign: 'center' }}
              >
                {translator._('signUp.alreayHaveAnAccount')}&nbsp;login
                <Link href="/login">{translator._('loginPage.login')}</Link>
              </Typography>
            </MHidden>
          </ContentStyle>
        </Container>
      </RootStyle>
    )
  }

  componentDidUpdate() {
    const { snackbar, enqueueSnackbar, dispatch } = this.props
    if (snackbar.messages) {
      snackbar.messages.forEach(message => {
        message.messageIds.forEach(messageId => {
          enqueueSnackbar(translator._(messageId), {
            preventDuplicate: true,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          })
        })
        dispatch(snackbarDispose(message.id))
      })
    }
  }
}

const mapStateToProps = response => ({
  authentication: response.authentication,
  snackbar: response.snackbar,
  process: response.process,
})
export default connect(mapStateToProps)(withSnackbar(Register))
